// extracted by css-extract-rspack-plugin
export default {"tableContainer":"ProqXt1YJsIlgFyg"};